module.exports = __webpack_public_path__ + "static/media/bg_ring.f0ef0ef1.svg";